export const DEFAULT_TOAST_DURATION = 3000
